module.exports = __webpack_public_path__ + "static/media/heart31.ae732ce2.svg";